import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const DismissTeamTemplatePickerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissTeamTemplatePicker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOneTimeMessagesDismissed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"DismissTeamTemplatePicker","document":DismissTeamTemplatePickerDocument}} as const;
export type DismissTeamTemplatePickerMutationVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
  messageId: Types.Scalars['ID']['input'];
}>;


export type DismissTeamTemplatePickerMutation = (
  { __typename: 'Mutation' }
  & { addOneTimeMessagesDismissed?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);

export type DismissTeamTemplatePickerMutationFn = Apollo.MutationFunction<
  DismissTeamTemplatePickerMutation,
  DismissTeamTemplatePickerMutationVariables
>;

/**
 * __useDismissTeamTemplatePickerMutation__
 *
 * To run a mutation, you first call `useDismissTeamTemplatePickerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissTeamTemplatePickerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissTeamTemplatePickerMutation, { data, loading, error }] = useDismissTeamTemplatePickerMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDismissTeamTemplatePickerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissTeamTemplatePickerMutation,
    DismissTeamTemplatePickerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DismissTeamTemplatePickerMutation,
    DismissTeamTemplatePickerMutationVariables
  >(DismissTeamTemplatePickerDocument, options);
}
export type DismissTeamTemplatePickerMutationHookResult = ReturnType<
  typeof useDismissTeamTemplatePickerMutation
>;
export type DismissTeamTemplatePickerMutationResult =
  Apollo.MutationResult<DismissTeamTemplatePickerMutation>;
export type DismissTeamTemplatePickerMutationOptions =
  Apollo.BaseMutationOptions<
    DismissTeamTemplatePickerMutation,
    DismissTeamTemplatePickerMutationVariables
  >;
